import v0_0_16 from './versions/0.0.16';
import v0_0_15 from './versions/0.0.15';
import v0_0_14 from './versions/0.0.14';
import v0_0_13 from './versions/0.0.13';
import v0_0_12 from './versions/0.0.12';
import v0_0_11 from './versions/0.0.11';
import v0_0_10 from './versions/0.0.10';

export const changeLog = {
  '0.0.16': v0_0_16,
  '0.0.15': v0_0_15,
  '0.0.14': v0_0_14,
  '0.0.13': v0_0_13,
  '0.0.12': v0_0_12,
  '0.0.11': v0_0_11,
  '0.0.10': v0_0_10,
};
